import { BaseResource } from '/@/modules/core/app/resources/BaseResource';
import { Route } from '/@/modules/core/app/constants/api.constants';

export class CurrentEstateResource extends BaseResource {
  async setCurrentEstate(params = {}) {
    return this.postData(Route.ESTATES_SET_ESTATE, params);
  }

  async clearCurrentEstate() {
    return this.postDataWithBlocking(Route.ESTATES_CLEAR_ESTATE);
  }
}

export default new CurrentEstateResource();
